import * as React from 'react';
import { useErrorLog } from '@core-front/error-provider';
const getPlaceholder = (aspectRatio) => {
    if (aspectRatio) {
        return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${aspectRatio.width} ${aspectRatio.height}"%3E%3C/svg%3E`;
    }
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
};
const ImageImg = (props) => {
    const BEM = () => {
        const classArray = ['image', 'lazyload'];
        if (props.shape) {
            classArray.push('image--' + props.shape);
        }
        if (props.align) {
            classArray.push('image--' + props.align);
        }
        if (props.isInactive) {
            classArray.push('image--inactive');
        }
        if (props.noFade) {
            classArray.push('image--no-fade');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("img", { key: props.src || props.srcset, src: getPlaceholder(props.aspectRatio), "data-src": props.src, "data-srcset": props.srcset, "data-sizes": props.srcset ? 'auto' : undefined, className: BEM(), alt: props.role === 'presentation' ? '' : props.alt, width: props.width, onError: props.onError, onLoad: props.onLoad, style: props.style, ref: props.imageRef }));
};
const ImagePicture = (props) => {
    return (React.createElement("picture", { className: props.pictureClassName },
        props.sources.map((item, index) => {
            return (React.createElement("source", { key: index, srcSet: item.aspectRatio && getPlaceholder(item.aspectRatio), "data-srcset": item.srcset, media: `(min-width: ${item.minWidth})` }));
        }),
        React.createElement(ImageImg, Object.assign({}, props))));
};
const Image = (props) => {
    const { role, alt, src, sources, srcset } = props;
    const { log } = useErrorLog();
    React.useEffect(() => {
        if (role !== 'presentation' && !alt) {
            const srcIndentifier = src ? `src: ${src}` : undefined;
            const srcSetIndentifier = srcset ? `srcset: ${srcset}` : undefined;
            log(`react-front: image is missing required alt prop (${srcSetIndentifier || srcIndentifier})`);
        }
    }, [role, alt, src, srcset, log]);
    return sources ? React.createElement(ImagePicture, Object.assign({}, props, { sources: sources })) : React.createElement(ImageImg, Object.assign({}, props));
};
export default Image;
